import React from "react";

import LogoNav from "../Assets/LogoNav";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  LinkHome,
  LinkQuienesSomos,
  LinkProductos,
  LinkOperacion,
  LinkContacto,
  LinkLinkedinIcon,
} from "../Assets/Variables";

const Footer = () => {

  const location = useLocation();
  const pathname = location.pathname;
  const isEnglish = pathname.startsWith("/en");

  return (
    <footer>
      <div
        className="container"
        style={{ backgroundImage: `url('../assets/img/bkglogo.webp')` }}
      >
        <div className="info">
          <LogoNav to={isEnglish ? "/en" : "/"} />
          <div className="social">{LinkLinkedinIcon}</div>
        </div>
        <div className="menu">
          <LinkHome />
          <LinkQuienesSomos />
          <LinkProductos />
          <LinkOperacion />
          <LinkContacto />
        </div>
        <div className="leyenda">
          <Link to="/">yaskia.com</Link> <span>|</span>{" "}
          <a
            href="mailto:yasminabdala@yaskia.com"
            target="_BLANK"
            rel="noreferrer"
          >
            yasminabdala@yaskia.com
          </a>{" "}
          {/* <span>|</span>{" "}
          <a href="tel:+5492804828528">280 482 8528</a> */}
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
